enum FinanceFilterEnum {
  HIGH_COST_LOAN = 'Loan',
  CREDIT_AND_STORE_CARDS = 'Credit Card',
}

export { FinanceFilterEnum };
